module.exports = __webpack_public_path__ + "img/emoji_34.599002bf.png";